import dayjs from 'dayjs'

export const SESSION_KEY_NAME = 'betin_betslip'

export type TBetinSessionKey =
    | 'exp'
    | 'loc'
    | 'sid'
    | 'ver'
    | 'dontShowPMUPromptAgain'
export type TBetinSession = {
    [key in TBetinSessionKey]: string
}

export const addToSessionStorage = (key: TBetinSessionKey, value: string) => {
    const sessionItem = JSON.parse(
        window.sessionStorage.getItem(SESSION_KEY_NAME) || '{}'
    ) as TBetinSession
    const sessionValue = {
        ...sessionItem,
        ...{
            exp: sessionItem.exp || dayjs().add(1, 'day').toISOString(),
            [key]: value
        }
    }
    console.debug('[BETSLIP] addToSessionStorage()', { key, value })
    window.sessionStorage.setItem(
        SESSION_KEY_NAME,
        JSON.stringify(sessionValue)
    )
}

export const getFromSessionStorage = <T>(key: TBetinSessionKey) => {
    const item = window.sessionStorage.getItem(SESSION_KEY_NAME)
    if (!item) return null
    const value = JSON.parse(item) as TBetinSession
    return value[key] as T
}

export const renewSession = (force?: boolean): void => {
    const value = JSON.parse(
        window.sessionStorage.getItem(SESSION_KEY_NAME) || '{}'
    )
    // If the session has expired, remove it, reset values and return null
    if (force || dayjs().isAfter(value.exp)) {
        window.sessionStorage.removeItem(SESSION_KEY_NAME)
    }
}
